import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useSiteContent } from '../context/SiteContentContext';
import { resolveImageUrl } from '../utils/urls';

const ProductCategories = () => {
  const { productCategories } = useSiteContent();
  const visibleCategories = productCategories.filter(
    (c) => c.id !== 'odn' && c.id !== 'fiber-cables'
  );

  return (
    <section
      id="products"
      className="py-16 lg:py-24 bg-gradient-to-b from-white to-blue-50/40"
      data-testid="products-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <p className="text-sm font-semibold text-[#0a3d8f] uppercase tracking-widest mb-2">Produk Kami</p>
          <h2 className="text-3xl lg:text-4xl font-extrabold text-gray-900">Solusi Komunikasi Optik Lengkap</h2>
          <div className="section-divider"></div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {visibleCategories.map((cat) => (
            <Link
              key={cat.id}
              to={`/produk/${cat.id}`}
              data-testid={`product-card-${cat.id}`}
              className="product-card bg-white rounded-xl overflow-hidden shadow-md border border-gray-100 block group"
            >
              <div className="relative h-48 overflow-hidden bg-gradient-to-br from-blue-50 to-white">
                <img src={resolveImageUrl(cat.image)} alt={cat.name} className="card-img w-full h-full object-contain p-4" />
                <div className="absolute top-3 left-3 bg-[#0a3d8f] text-white px-3 py-1 rounded-full text-xs font-semibold shadow-md">
                  {cat.nameId}
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2 font-[Montserrat]">{cat.name}</h3>
                <p className="text-sm text-gray-600 mb-4 leading-relaxed line-clamp-3">{cat.description}</p>
                <div className="flex items-center justify-between text-sm font-semibold text-[#0a3d8f] group-hover:text-[#082e6b]">
                  <span>Lihat Selengkapnya</span>
                  <ArrowRight size={14} className="transition-transform group-hover:translate-x-1" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductCategories;
